import { Entity } from "@jobilla/entity";

export class Unit extends Entity {
  id!: string;
  name!: string;
  type!: string;
  parentUnitId!: string | null;
}
